import { State } from '../../types';

export const montana: State = {
  name: 'Montana',
  abbreviation: 'MT',
  terms: [
    {
      word: 'Absarokee',
      phonetic: 'ab-SOR-kee',
      // audioUrl: '/audio/absarokee.mp3',
      description: 'A town in Stillwater County, often mispronounced due to its unique spelling.'
    },
    {
      word: 'Butte',
      phonetic: 'BYOOT',
      audioUrl: '/audio/butte.mp3',
      description: 'Mining city in southwestern Montana'
    },
    {
      word: 'Choteau',
      phonetic: 'SHO-toe',
      // audioUrl: '/audio/choteau.mp3',
      description: 'A city in Teton County, pronounced differently from its French origin.'
    },
    {
      word: 'Ekalaka',
      phonetic: 'ee-kuh-LAK-uh',
      // audioUrl: '/audio/ekalaka.mp3',
      description: 'A town in Carter County, named after a Sioux woman, with a pronunciation that may surprise newcomers.'
    },
    {
      word: 'Havre',
      phonetic: 'HAV-ur',
      // audioUrl: '/audio/havre.mp3',
      description: 'A city in Hill County, named after Le Havre, France, but pronounced differently.'
    },
    {
      word: 'Helena',
      phonetic: 'HEL-en-uh',
      // audioUrl: '/audio/helena.mp3',
      description: 'The capital city of Montana, often mispronounced as "Hell-EE-nuh."'
    },
    {
      word: 'Meagher County',
      phonetic: 'MAR',
      // audioUrl: '/audio/meagher_county.mp3',
      description: 'A county in Montana, pronounced "MAR" instead of "Meager."'
    },
    {
      word: 'Olney',
      phonetic: 'ALL-nee',
      // audioUrl: '/audio/olney.mp3',
      description: 'A community in Flathead County, pronounced with an "AWL" sound.'
    },
    {
      word: 'Pondera',
      phonetic: 'pon-der-AY',
      // audioUrl: '/audio/pondera.mp3',
      description: 'A county in Montana, pronounced similarly to "Pend d’Orielle."'
    },
    {
      word: 'Ravalli',
      phonetic: 'ruh-VAL-lee',
      // audioUrl: '/audio/ravalli.mp3',
      description: 'A county in Montana, often mispronounced as "ruh-VOLL-ee."'
    },
    {
      word: 'Ronan',
      phonetic: 'row-NAN',
      // audioUrl: '/audio/ronan.mp3',
      description: 'A city in Lake County, pronounced "row-NAN" instead of "ROW-nan."'
    },
    {
      word: 'Wibaux',
      phonetic: 'WEE-boh',
      // audioUrl: '/audio/wibaux.mp3',
      description: 'A town in Wibaux County, named after Pierre Wibaux, with a pronunciation that may not be intuitive.'
    },
    {
      word: 'Yaak',
      phonetic: 'YAK',
      // audioUrl: '/audio/yaak.mp3',
      description: 'An unincorporated community in Lincoln County, pronounced "YAK" despite its double "a."'
    }
  ]
};